import { render } from "./TermsHeader.vue?vue&type=template&id=d20dfa32"
import script from "./TermsHeader.vue?vue&type=script&lang=js"
export * from "./TermsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__